'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = info;
function info(_ref, _, _ref2) {
  var document = _ref.document,
      santaBase = _ref.santaBase,
      boltBase = _ref.boltBase,
      clientSideRender = _ref.clientSideRender,
      timeSpentInSSR = _ref.timeSpentInSSR,
      santaRenderingError = _ref.santaRenderingError,
      navigator = _ref.navigator,
      performance = _ref.performance,
      rendererModel = _ref.rendererModel,
      _ref$ssrInfo = _ref.ssrInfo,
      ssrInfo = _ref$ssrInfo === undefined ? {} : _ref$ssrInfo;
  var dc = _ref2.dc,
      initialTimestamp = _ref2.initialTimestamp,
      renderType = _ref2.renderType,
      isCached = _ref2.isCached,
      caching = _ref2.caching,
      microPop = _ref2.microPop,
      wixBoltExclusionReason = _ref2.wixBoltExclusionReason;

  var total = function total(field) {
    return function (records) {
      return _.reduce(records, function (result, record) {
        return result + record[field];
      }, 0);
    };
  };
  var totalTransfer = total('transferSize');
  var totalSize = total('decodedBodySize');

  var round = function round(record) {
    return _.reduce(record, function (result, value, key) {
      result[key] = _.isNumber(value) ? Math.round(value) : value;
      return result;
    }, {});
  };

  var kb = function kb(bytes) {
    return bytes >> 10;
  };
  var mb = function mb(bytes) {
    return Math.round(bytes / 1024 / 1024);
  };

  var getEntries = function getEntries(resourceType) {
    return function (filter) {
      return _(resourceType ? performance.getEntriesByType(resourceType) : performance.getEntries()).invokeMap('toJSON').filter(filter).value();
    };
  };
  var getResources = getEntries('resource');
  var getNavigation = function getNavigation() {
    return getEntries('navigation')(_.identity)[0];
  };
  var getStages = function getStages() {
    return getEntries()(function (_ref3) {
      var entryType = _ref3.entryType;
      return ['mark', 'paint'].includes(entryType);
    });
  };

  return function () {
    if (!console.table) {
      console.log('Old browser: no info to show');
      return;
    }

    console.log('%cSystem info', 'color:blue; font-weight:bold');
    var system = [['User agent', navigator.userAgent]];
    if (navigator.connection && navigator.connection.effectiveType) {
      system.push(['Network type', navigator.connection.effectiveType]);
    }
    if (performance.memory && performance.memory.jsHeapSizeLimit) {
      system.push(['Heap size (MB)', mb(performance.memory.jsHeapSizeLimit)]);
    }
    console.table(system);

    console.log('%cResources info', 'color:blue; font-weight:bold');
    var scripts = getResources(function (_ref4) {
      var initiatorType = _ref4.initiatorType,
          name = _ref4.name;
      return initiatorType === 'script' || /\.js$/.test(name);
    });
    var fonts = getResources(function (_ref5) {
      var initiatorType = _ref5.initiatorType,
          name = _ref5.name;
      return initiatorType === 'css' && /font/i.test(name);
    });
    var resources = [['Script file count', scripts.length], ['Script file size (KB)', kb(totalTransfer(scripts))], ['Script protocol', scripts[0].nextHopProtocol], ['Fonts file count', fonts.length], ['Fonts file size (KB)', kb(totalTransfer(fonts))], ['iframe count', document.querySelectorAll('iframe').length], ['Comps count', document.querySelectorAll('#SITE_ROOT *[id^=comp-]').length]];
    if (clientSideRender) {
      var xhrs = getResources(function (_ref6) {
        var name = _ref6.name;
        return name.includes('fixedData');
      });
      resources.push(['Page JSONs size (KB)', kb(totalSize(xhrs))]);
    }
    console.table(resources);

    var navigation = getNavigation();
    if (navigation) {
      console.log('%cResponse info', 'color:blue; font-weight:bold');
      var HTMLserver = [['Load type', navigation.type], ['Using DC', dc]];
      if (microPop) {
        HTMLserver.push(['Using micro-POP', microPop]);
      }
      HTMLserver.push(['Size over the wire (KB)', kb(navigation.transferSize)], ['Size on client (KB)', kb(navigation.decodedBodySize)], ['DNS time', Math.round(navigation.domainLookupEnd - navigation.domainLookupStart)]);
      if (navigation.secureConnectionStart) {
        HTMLserver.push(['TCP handshake', Math.round(navigation.secureConnectionStart - navigation.connectStart)], ['SSL handshake', Math.round(navigation.connectEnd - navigation.secureConnectionStart)]);
      } else {
        HTMLserver.push(['TCP handshake', Math.round(navigation.connectEnd - navigation.connectStart)]);
      }
      HTMLserver.push(['Request / response', Math.round(navigation.responseStart - navigation.requestStart)]);
      console.table(HTMLserver);
    }

    var platformOnPage = ssrInfo.platformOnPage,
        platformAppsOnPage = ssrInfo.platformAppsOnPage,
        userCode = ssrInfo.userCode;

    if (platformOnPage) {
      console.log('%cPlatform info', 'color:blue; font-weight:bold');
      var platform = [['Using platform', platformOnPage]];
      var clientSpecs = Object.values(rendererModel.clientSpecMap);
      var apps = platformAppsOnPage.map(function (appDefId) {
        var app = clientSpecs.find(function (_ref7) {
          var appDefinitionId = _ref7.appDefinitionId;
          return appDefinitionId === appDefId;
        });
        return app && app.appDefinitionName || appDefId;
      });
      platform.push(['Apps', apps.join()], ['Using Code', userCode]);
      console.table(platform);
    }

    console.log('%cTiming info', 'color:blue; font-weight:bold');
    var stages = getStages().map(round);
    if (!stages[0].name.includes('Init') && performance.timeOrigin) {
      stages.unshift({ name: 'Init (beat 1)', startTime: Math.round(initialTimestamp - performance.timeOrigin) });
    }
    console.table(stages, ['name', 'startTime']);

    console.log('%cSession info', 'color:blue; font-weight:bold');
    var isBolt = renderType === 'bolt';
    var version = isBolt ? boltBase : santaBase;
    var tssr = ssrInfo.timeSpentInSSR || timeSpentInSSR;
    var session = [['Version', renderType + ' (' + version.match(/\/([^/]+)$/)[1] + ')'], ['Using SSR', !clientSideRender]];
    if (clientSideRender) {
      if (santaRenderingError) {
        session.push(['No SSR reason', santaRenderingError.errorInfo]);
      }
    } else if (isCached) {
      session.push(['SSR caching', caching + ' (' + (tssr || 'unknown') + ')']);
    } else if (tssr) {
      session.push(['SSR time', tssr]);
    }
    if (!isBolt && wixBoltExclusionReason) {
      session.push(['Bolt exclusion reason', wixBoltExclusionReason]);
    }
    console.table(session);
  };
}
//# sourceMappingURL=info.js.map